import i18n from '@/lib/language'
const dayTime = i18n.t('message["670"]').split('|')
const baseUnitPrice = (num) => {
  if (num >= 1 && num <= 20) {
    return 440
  } else if (num >= 21 && num <= 50) {
    return 430
  } else if (num >= 51 && num <= 80) {
    return 415
  } else {
    return 395
  }
}
/**
 *
 * @param {*} timestamp 时间戳
 * @param {*} type 1:开始时间，2:到期时间（到期时间需减一天）
 */
const timestampToFormat = (timestamp, type = 1) => {
  let date = new Date(timestamp * 1000)
  let Y = date.getFullYear()
  let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
  let D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  if (type === 2) {
    date = new Date(date.setTime(date.getTime() - 24 * 60 * 60 * 1000))
    M = date.getMonth() + 1 > 9 ? date.getMonth() + 1 + '' : '0' + (date.getMonth() + 1)
    D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  }
  return Y + '-' + M + '-' + D
}
/**
 *
 * @param {*} time 时间戳
 * @param {*} number 增加的年份
 * @param {*} type 1:开始时间，2:到期时间（到期时间需减一天）
 */
const getDateTime = (time, number = 0, type = 1) => {
  if (time) {
    let date = isNumber(time) ? new Date(time * 1000) : time
    date.setFullYear(date.getFullYear() + number)
    let year = date.getFullYear()
    let month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 + '' : '0' + (date.getMonth() + 1)
    let day = date.getDate() > 9 ? date.getDate() + '' : '0' + date.getDate()
    if (type === 2) {
      date = new Date(date.setTime(date.getTime() - 24 * 60 * 60 * 1000))
      month = date.getMonth() + 1 > 9 ? date.getMonth() + 1 + '' : '0' + (date.getMonth() + 1)
      day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
    }
    return year + '-' + month + '-' + day
  }
}

const checkMoreSmsNumber = (rule, value, callback) => {
  if (value > 100000000) {
    callback(new Error(i18n.t('message["399"]')))
  }
  if (value === 0 || value > 2000) {
    callback()
    return
  }
  callback(new Error(i18n.t('message["752"]')))
}

const getFixed = value => {
  if (isNaN(value)) {
    return 0
  }
  return Math.floor(value * 100) / 100
}

const isNumber = (val) => {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true
  } else {
    return false
  }
}

export {
  baseUnitPrice,
  timestampToFormat,
  getDateTime,
  checkMoreSmsNumber,
  getFixed,
  isNumber
}
